// kfe-listening-meter.js — Listening Stage meter (type 18).
//
// iOS REFERENCE: KFEListeningMeterVC — a table with a Title row + SIX answer
// rows (Q1 best … Q6 worst). Tapping row `tag` (1..6) sets
// `answer1 = 6 - tag + 1` (KFEListeningMeterVC.m:96-98), i.e. Q1→6, Q6→1. One
// pass threshold, compared with a STRICT `<` (m:314). Direction is HARDCODED
// preceding (m:303 `isPreceding = YES`) — never read from data.
//
// Brief 055: presented here as a radio-style selector (one of six options) plus
// a Confirm button, then the iOS feedback screen. answer2 is unused.

import { html } from "../core/html.js";
import { t } from "../core/i18n.js";
import { KFEMeterBase, METER_MODAL_STYLES } from "./kfe-meter-base.js";

const OPTION_COUNT = 6;

export class KFEListeningMeter extends KFEMeterBase {
  static styles = METER_MODAL_STYLES;

  constructor() {
    super();
    /** @type {"input"|"feedback"} */ this._phase = "input";
    /** 0-based selected option index; -1 = none. Option 0 is the best ("Q1"). */
    this._selectedIndex = -1;
  }

  /** iOS mapping: option index 0..5 → answer1 6..1 (6 = best listening). */
  get _answer1() {
    return this._selectedIndex < 0 ? 0 : OPTION_COUNT - this._selectedIndex;
  }

  _select(i) {
    this._selectedIndex = i;
    this._scheduleRender();
  }

  _confirm() {
    if (this._phase !== "input" || this._selectedIndex < 0) return;
    this._phase = "feedback";
    this._scheduleRender();
  }

  render() {
    const card = document.createElement("div");
    card.className = "card";

    if (this._phase === "feedback") {
      card.appendChild(this._feedbackNode("listening", this._answer1, null));
      return html`${card}`;
    }

    const h2 = document.createElement("h2");
    h2.textContent = this._title();
    card.appendChild(h2);

    const prompt = document.createElement("p");
    prompt.className = "prompt";
    prompt.textContent = t("meter.listening.prompt");
    card.appendChild(prompt);

    const ul = document.createElement("ul");
    ul.className = "options";
    ul.setAttribute("role", "radiogroup");
    for (let i = 0; i < OPTION_COUNT; i++) {
      const li = document.createElement("li");
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "opt";
      btn.setAttribute("role", "radio");
      btn.setAttribute("aria-checked", String(i === this._selectedIndex));
      btn.textContent = t(`meter.listening.option${i + 1}`);
      btn.addEventListener("click", () => this._select(i));
      li.appendChild(btn);
      ul.appendChild(li);
    }
    card.appendChild(ul);

    const actions = document.createElement("div");
    actions.className = "actions";
    const confirm = document.createElement("button");
    confirm.type = "button";
    confirm.className = "confirm";
    confirm.textContent = t("meter.confirm");
    confirm.disabled = this._selectedIndex < 0;
    confirm.addEventListener("click", () => this._confirm());
    actions.appendChild(confirm);
    card.appendChild(actions);

    return html`${card}`;
  }
}
